import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '../components/Home.vue')
    },
    {
      path: '/details/:id',
      name: 'details',
      props:true,
      component: () => import(/* webpackChunkName: "details" */ '../components/Detail.vue')
    },
    {
      path: '/post',
      name: 'post',
      component: () => import(/* webpackChunkName: "post" */ '../components/Post.vue')
    }
  ]
})
